var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailRoundLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email-round-line-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0ZM33.29,38.65h56.3a3.65,3.65,0,0,1,3.64,3.64V81a3.57,3.57,0,0,1-.63,2,1.46,1.46,0,0,1-.34.52,1.51,1.51,0,0,1-.34.24,3.7,3.7,0,0,1-2.33.85H33.29a3.63,3.63,0,0,1-2.57-1.07A3.67,3.67,0,0,1,29.65,81V42.29a3.65,3.65,0,0,1,3.64-3.64Zm-.85,40.79L52.17,59.67,32.44,43.58V79.44Zm21.9-18L34,81.83H88.7L69.27,61.44,62.86,66.9h0a1.39,1.39,0,0,1-1.79,0l-6.73-5.48Zm17-1.81,19,20V43.41l-19,16.22ZM34.24,41.44,61.93,64,88.44,41.44Zm68-20.81a57.7,57.7,0,1,0,16.91,40.81,57.5,57.5,0,0,0-16.91-40.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRoundLine);
export default __webpack_public_path__ + "static/media/email-round-line.c9e86cbe97c6d894abbeeb93b0e0fd87.svg";
export { ForwardRef as ReactComponent };